import { actionsNameSchema } from "modules/shared/schemas/actionsSchemas";
import { QrcodesListBody } from "../schemas/customQrcodeSchema";

export const transformQrcodeList = (data: QrcodesListBody) =>
  data.map((qrcode) => ({
    ...qrcode,
    actions: [actionsNameSchema.enum.insert, actionsNameSchema.enum.write],
  }));
